
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiInstance from '../utils/apiInstance';
import countryCodes from '../utils/CountryCodes.json';
import { imageBaseUrl } from '../utils/apiInstance';
import { ToastContainer, toast } from 'react-toastify';
import 'react-tooltip/dist/react-tooltip.css'

const EditRestaurant = () => {
    const { _id } = useParams();
    const [owner, setOwner] = useState({});
    const [restaurant, setRestaurant] = useState({});
    const [countryCode, setCountryCode] = useState([]);
    const [imagePreview, setImagePreview] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();


    useEffect(() => {
        const fetchRestaurantData = async () => {
            try {
                const response = await apiInstance.get(`/viewRestaurant/${_id}`);
                setOwner(response.data?.restaurantDetails?.user);
                setRestaurant(response.data?.restaurantDetails);
                setImagePreview(
                    response.data.restaurantDetails?.user?.image
                        ? `${imageBaseUrl}/${response.data.restaurantDetails?.user?.image}`
                        : null
                );
            } catch (err) {
                setError("An error occurred while fetching restaurant details");
            } finally {
                setLoading(false);
            }
        };

        fetchRestaurantData();
        setCountryCode(countryCodes);
    }, [_id]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image" && files.length > 0) {
            const file = files[0];
            if (!file.type.startsWith("image/")) {
                toast.error("Please select a valid image file");
                return;
            }
            setOwner((prevData) => ({
                ...prevData,
                [name]: file,
            }));
            setImagePreview(URL.createObjectURL(file));
        } else if (name === "ownerCountry_code") {
            setOwner((prevData) => ({
                ...prevData,
                country_code: value,
            }));
        } else if (name === "ownerName") {
            setOwner((prevData) => ({
                ...prevData,
                name: value,
            }));
        } else if (name === "ownerLocation") {
            setOwner((prevData) => ({
                ...prevData,
                location: value,
            }));
        } else if (name === "email") {

            setOwner((prevData) => ({
                ...prevData,
                email: value,
            }));
        } else if (name === "ownerPhone") {

            setOwner((prevData) => ({
                ...prevData,
                phone: value,
            }));
        }
        else {
            setRestaurant((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (
            !owner.country_code ||
            !owner.name?.trim() ||
            !owner.location ||
            !owner.phone ||
            !owner.email ||
            !restaurant.name ||
            !restaurant.address ||
            !restaurant.phone ||
            !restaurant.open_time ||
            !restaurant.close_time
        ) {
            toast.error("Please fill in all required fields");
            return;
        }
        if (owner.image && owner.image.size > (1024 * 1024 * 6)) {
            toast.error("Image size must be less than 6MB");
            return;
        }
        if (!/^[A-Za-z\s]+$/.test(owner.name)) {
            toast.error("Enter a valid owner name");
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(owner.email)) {
            toast.error("Enter a valid email address");
            return;
        }
        if (isNaN(owner.phone)) {
            toast.error("Enter a valid owner's phone number");
            return;
        }

        if (isNaN(restaurant.phone)) {
            toast.error("Enter a valid restaurant's phone number");
            return;
        }


        const formData = new FormData();
        formData.append("ownerCountry_code", owner.country_code);
        formData.append("ownerName", owner.name);
        formData.append("ownerPhone", owner.phone);
        formData.append("email", owner.email);
        formData.append("ownerLocation", owner.location);
        formData.append("restaurantName", restaurant.name);
        formData.append("restaurantAddress", restaurant.address);
        formData.append("restaurantCountry_code", restaurant.country_code);
        formData.append("restaurantPhone", restaurant.phone);
        formData.append("close_time", restaurant.close_time);
        formData.append("open_time", restaurant.open_time);


        if (owner.image) {
            formData.append("image", owner.image);
        }
        setLoading(true);
        try {
            await apiInstance.put(`/editRestaurant/${_id}`, formData);
            toast.success("Restaurant details updated successfully");
            setTimeout(() => {
                navigate(-1);
            }, 1000);
        } catch (error) {
            if (error.response) {
                toast.error(
                    `${error.response.data?.message || "Something went wrong"
                    }`
                );
            } else {
                toast.error("Request failed: Network error or server is down");
            }
        } finally {
            setLoading(false);
        }
    };


    if (error) return <div>{error}<br />Please try again after some time or check your internet connection.</div>;

    return (
        <>
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={true} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card my-4">
                            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                <div className="bg-info shadow-dark border-radius-lg">
                                    <h6 className="text-white text-capitalize ps-3">
                                        Edit Restaurant Details
                                    </h6>
                                </div>
                            </div>
                            <form onSubmit={handleSubmit} style={{ position: 'relative' }}>
                                {loading && (
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                                            zIndex: 1000,
                                        }}
                                    >
                                        <div className="spinner-border text-info" role="status" style={{ width: '50px', height: '50px' }}>
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                <div className="card-body">
                                    <div className="form-group col-3 mx-auto d-flex justify-content-center">
                                        <div className="restaurant_profile mt-2" data-aspect="1/1">
                                            {imagePreview && (
                                                <img
                                                    src={imagePreview}
                                                    alt="Preview"
                                                    style={{
                                                        borderRadius: "10px",
                                                        width: "200px",
                                                        height: "200px",
                                                        marginBottom: "5px",
                                                    }}
                                                />
                                            )}
                                            <input
                                                type="file"
                                                name="image"
                                                className="form-control"
                                                accept=".jpg,.jpeg,.png"
                                                onChange={handleChange}
                                                style={{
                                                    paddingLeft: "10px",
                                                    width: '200px'
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-5 ">
                                        <div className="shadow-dark border-radius-lg ps-3 py-1" style={{ backgroundColor: "#0d6efd" }}>
                                            <h6 style={{ color: "white" }}>Owner Details</h6>
                                        </div>
                                        <div className='row mt-2'>
                                            <div className='col-lg-6'>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="ownerName">Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        autoComplete='off'
                                                        name="ownerName"
                                                        value={owner.name || ""}
                                                        onChange={handleChange}

                                                    />
                                                </div>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="ownerPhone">Phone No.</label>
                                                    <div className="d-flex">
                                                        <select
                                                            name="ownerCountry_code"
                                                            className="form-control cursor-pointer me-1"
                                                            required
                                                            value={owner.country_code || ""}
                                                            onChange={handleChange}
                                                            style={{
                                                                width: "75px",
                                                                paddingLeft: "10px",
                                                                color: 'white'
                                                            }}
                                                        >
                                                            {countryCode.map((code, index) => (
                                                                <option key={index} value={code.code}>
                                                                    {code.code}
                                                                </option>
                                                            ))}

                                                            {!countryCode.some(
                                                                (countryCode) => countryCode === owner.country_code
                                                            ) &&
                                                                owner.country_code && (
                                                                    <option value={owner.country_code}>
                                                                    </option>
                                                                )}
                                                        </select>
                                                        <input
                                                            type="tel"
                                                            className="form-control"
                                                            required
                                                            autoComplete='off'
                                                            name="ownerPhone"
                                                            value={owner.phone || ""}
                                                            onChange={handleChange}
                                                            style={{
                                                                flex: 1,
                                                                paddingLeft: "10px",
                                                                color: 'white'
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group mb-2">
                                                    <label htmlFor="email">Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        required
                                                        autoComplete='off'
                                                        name="email"
                                                        value={owner.email || ""}
                                                        onChange={handleChange}
                                                        readOnly
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>

                                                <div className="form-group mb-2">
                                                    <label htmlFor="ownerAddress">Address</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        autoComplete='off'
                                                        name="ownerLocation"
                                                        value={owner.location || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-5 ">
                                        <div className="shadow-dark border-radius-lg ps-3 py-1" style={{ backgroundColor: "#0d6efd" }}>
                                            <h6 style={{ color: "white" }}>Restaurant Details</h6>
                                        </div>
                                        <div className='row mt-2'>
                                            <div className='col-lg-6'>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="restaurantName">Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        autoComplete='off'
                                                        name="name"
                                                        value={restaurant.name || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="restaurantPhone">Phone No.</label>
                                                    <div className="d-flex">

                                                        <select
                                                            name="country_code"
                                                            className="form-control cursor-pointer me-1"
                                                            required
                                                            value={restaurant.country_code || ""}
                                                            onChange={handleChange}
                                                            style={{
                                                                width: "75px",
                                                                paddingLeft: "10px",
                                                                color: 'white'
                                                            }}
                                                        >
                                                            {countryCode.map((code, index) => (
                                                                <option key={index} value={code.code}>
                                                                    {code.code}
                                                                </option>
                                                            ))}

                                                            {!countryCode.some(
                                                                (countryCode) => countryCode === restaurant.country_code
                                                            ) &&
                                                                restaurant.country_code && (
                                                                    <option value={restaurant.country_code}>
                                                                    </option>
                                                                )}
                                                        </select>
                                                        <input
                                                            type="tel"
                                                            className="form-control"
                                                            required
                                                            autoComplete='off'
                                                            name="phone"
                                                            value={restaurant.phone || ""}
                                                            onChange={handleChange}
                                                            style={{
                                                                flex: 1,
                                                                paddingLeft: "10px",
                                                                color: 'white'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group mb-2">
                                                    <label htmlFor="restaurantAddress">Address</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        autoComplete='off'
                                                        name="address"
                                                        value={restaurant.address || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>

                                            </div>
                                            <div className="col-lg-6">


                                                <div className="form-group mb-2">
                                                    <label htmlFor="openTime">Opening-Time</label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        required
                                                        autoComplete='off'
                                                        name="open_time"
                                                        value={restaurant.open_time || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>

                                                <div className="form-group mb-2">
                                                    <label htmlFor="closeTime">Closing-Time</label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        required
                                                        autoComplete='off'
                                                        name="close_time"
                                                        value={restaurant.close_time || ""}
                                                        onChange={handleChange}
                                                        style={{
                                                            paddingLeft: "10px",
                                                            color: 'white'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="mx-4 text-end">
                                    <button
                                        type="submit"
                                        className="btn btn-info"
                                        style={{ marginRight: "10px" }}
                                    >
                                        Update
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                        onClick={() => navigate(-1)}
                                    >
                                        Back
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditRestaurant;
